import {ShopItem} from './ShopItem';
import {OrderItem} from './OrderItem';
import {ReviewItem} from './ReviewItem';
import {ProfileItem} from './ProfileItem';
import {WishlistItem} from './WishlistItem';
import {FeaturedItem} from './FeaturedItem';
import {PromocodeItem} from './PromocodeItem';
import {BestSellerItem} from './BestSellerItem';

export const items = {
  ShopItem,
  OrderItem,
  ReviewItem,
  ProfileItem,
  WishlistItem,
  FeaturedItem,
  PromocodeItem,
  BestSellerItem,
};
